import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const GatePassesLazy = React.lazy(
	() => import(/* webpackChunkName : 'GatePasses' */ './components')
);

export default (store) => [
	{
		path: 'gate-passes',
		element: <AsyncLoading component={<GatePassesLazy />} />,
	},
];
